export type Effect = 'appear' | 'fade_in';

export default class FullScreenIllustrationRenderOptions {
  // eslint-disable-next-line no-useless-constructor
  constructor(public effect?: Effect) {}
}
